import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { AvailabilitySelectWrapper } from "../containers/Availability/AvailabilityLayoutComponents";

const AvailabilitySelectWrapperSkeleton = styled(AvailabilitySelectWrapper)(({ theme }) => ({
    gap: theme.spacing(2),
}));

const AvailabilityFooterWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(0.5),
    flexDirection: "column",
}));

export function ProductAvailabilitySkeleton() {
    return (
        <Paper elevation={1}>
            <AvailabilitySelectWrapperSkeleton>
                <Skeleton variant="rectangular" height={60}></Skeleton>
                <Skeleton variant="rectangular" height={56}></Skeleton>
                <AvailabilityFooterWrapper>
                    <Skeleton variant="rectangular" height={20} width="40%"></Skeleton>
                    <Skeleton variant="rectangular" height={20} width="70%"></Skeleton>
                    <Skeleton variant="rectangular" height={20} width="50%"></Skeleton>
                </AvailabilityFooterWrapper>
            </AvailabilitySelectWrapperSkeleton>
        </Paper>
    );
}
